export type SearchRequest<T> = {
  page?: number;
  pageSize?: number;
  sort?: string;
  order?: string;
  filters?: { [key in keyof T]?: T[keyof T] };
  operators?: { [key: string]: string };
};

export const searchRequestToUri = <T>(search: SearchRequest<T>): string => {
  const params = new URLSearchParams();

  if (search.page) params.append('page', (search.page ?? 1).toString());
  if (search.pageSize) params.append('pageSize', (search.pageSize ?? 10).toString());
  if (search.sort) params.append('sort', search.sort);
  if (search.order) params.append('order', search.order);

  if (search.filters) {
    Object.keys(search.filters).forEach(key => {
      const value = search.filters![key as keyof T];
      if (value) params.append(key, value.toString());
    });
  }

  return params.toString();
};
